<template>
  <div class="container-fluid px-5 mt-4">

    <!-- Nadpis -->
    <div class="d-flex align-items-center gap-3 mb-4 detail-page-header">
      <button class="btn file-detail__back-btn" @click="$router.back()">
        <img :src="iconChevronLeft" alt="">
      </button>
      <h1 class="credits-page__title mb-0">{{ $t('file.fileDetail') }}</h1>
      <span v-if="fileInfo?.name" class="cert-name-badge">{{ fileInfo.name }}</span>
    </div>

    <Skeletor v-if="loading" />

    <div v-if="!loading">

      <!-- Informační/chybová hláška -->
      <div v-if="message" class="file-sharing-message mb-5">
        <i class="bi bi-info-circle file-sharing-message__icon"></i>
        <p class="file-sharing-message__text">{{ message }}</p>
        <a
          v-if="statusCode === 401"
          :href="'/login?redirect_to=' + $route.fullPath"
          class="btn btn-primary mt-3"
        >{{ $t('general.signIn') }}</a>
      </div>

      <!-- Karta s informacemi o souboru -->
      <div v-if="fileInfo" class="row g-3 mb-4">
        <div class="col-12 col-xl-6">
          <div class="dashboard-section-header mb-3">
            <div class="d-flex align-items-center gap-2">
              <img :src="iconFileInfo" alt="" class="dashboard-section-header__icon">
              <span class="dashboard-section-header__title">{{ $t('file.fileInfo') }}</span>
            </div>
          </div>
          <div class="file-detail-card file-detail-card__body">
            <div class="profile-data-field">
              <span class="cert-list__label">{{ $t('file.fileName') }}</span>
              <span class="cert-list__value">{{ fileInfo.name }}</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Sekce náhledu souboru -->
      <div v-if="fileContentUrl">
        <div class="dashboard-section-header mb-3">
          <div class="d-flex align-items-center gap-2">
            <img :src="iconSpecialOk" alt="" class="dashboard-section-header__icon">
            <span class="dashboard-section-header__title">{{ $t('general.preview') }}</span>
          </div>
        </div>
        <div class="cert-detail__pdf-wrap mb-5">
          <div class="cert-detail__pdf-inner">
            <SharedFileView :key="fileContentUrl" :fileContentUrl="fileContentUrl" />
          </div>
        </div>
      </div>

    </div>

    <!-- Modál pro ověřovací kód (2FA) -->
    <transition name="page-fade">
      <div v-if="modalActive" class="create-cert-overlay" @click.self="closeModal">
        <div class="create-cert-modal" style="max-width: 440px;">

          <div class="create-cert-modal__header">
            <span class="create-cert-modal__title">{{ $t('general.verification') }}</span>
            <button class="create-cert-modal__close" type="button" @click="closeModal" aria-label="Close">×</button>
          </div>

          <div class="create-cert-modal__body">
            <label class="create-cert-label" for="verif-code">{{ $t('general.verificationCode') }}</label>
            <input
              type="text"
              class="create-cert-input mb-2"
              id="verif-code"
              v-model="verificationCode"
              :disabled="verifying"
              placeholder="123456"
            />
            <div v-if="verifyError" class="create-cert-error mb-3">{{ verifyError }}</div>
            <div class="d-flex justify-content-end mt-3">
              <button
                type="button"
                class="btn btn-primary"
                @click="submitVerification"
                :disabled="verifying || !verificationCode"
              >
                <span v-if="verifying" class="spinner-border spinner-border-sm me-2" role="status"></span>
                {{ verifying ? $t('general.verifying') : $t('general.verify') }}
              </button>
            </div>
          </div>

        </div>
      </div>
    </transition>

  </div>
</template>

<script>
import http from '@/http';
import SharedFileView from '../components/SharedFileView.vue';
import iconChevronLeft from '/public/img/new-design/icons/chevron-left.svg';
import iconFileInfo from '/public/img/new-design/icons/file_info.svg';
import iconSpecialOk from '/public/img/new-design/icons/special-ok-icon.svg';

export default {
  components: { SharedFileView },

  mounted() {
    this.getFileDetail();
  },

  data() {
    return {
      loading: true,
      message: null,
      statusCode: null,
      fileInfo: null,
      fileContentUrl: null,
      twoFRequired: false,
      modalActive: false,
      verificationCode: '',
      verifying: false,
      verifyError: null,
      iconChevronLeft,
      iconFileInfo,
      iconSpecialOk,
    };
  },

  methods: {
    getFileDetail(verificationCode = null) {
      const url = '/file-shares/' + this.$route.params.uuid
        + (verificationCode ? '?verification_code=' + encodeURIComponent(verificationCode) : '');

      http.get(url).then((response) => {
        this.message = response.data.info_message ?? null;
        this.statusCode = response.data.status_code ?? null;
        this.fileInfo = response.data.file_info ?? null;
        this.fileContentUrl = response.data.file_url ?? null;

        const twoF = response.data['2F_required'] === true || response.data['2F_required'] === 'true';
        this.twoFRequired = twoF;

        if (twoF && !this.fileContentUrl) {
          this.openModal();
        }

        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },

    openModal() {
      this.modalActive = true;
    },

    closeModal() {
      this.modalActive = false;
    },

    submitVerification() {
      this.verifyError = null;
      if (!this.verificationCode) return;
      this.verifying = true;
      this.getFileDetail(this.verificationCode);
      this.closeModal();
      this.verifying = false;
    },
  },
};
</script>

<style scoped>
.file-sharing-message {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  background: #F8F8F8;
  text-align: center;
}
.file-sharing-message__icon {
  font-size: 36px;
  color: #7D7E91;
  margin-bottom: 16px;
}
.file-sharing-message__text {
  font-size: 15px;
  color: #101827;
  margin: 0;
}
</style>